<!-- <div class="cajaDevelopmentMode" *ngIf="!environment.production">
  <div class="cintaDevelopmentMode">
      Desarrollo
  </div>
</div> -->
<!-- <button class="btn btn-primary" (click)="cambiarTema()" style="position: absolute;top: 10%; left: 5%; z-index: 2;">Toggle Theme</button> -->
<app-header-pag *ngIf="empresa" [cod_empresa]="empresa" class="fast fadeIn2 animated"></app-header-pag>
<router-outlet class="fast fadeIn2 animated"></router-outlet>
